<template>
  <v-footer v-if="isDesktop" app class="theme--dark" fixed
    ><span class="mx-auto"
      >Copyright © {{ new Date() | moment("YYYY") }} All Rights Reserved.</span
    >
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  watch: {
    isDesktop: (value) => {
      if (value) {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    isDesktop() {
      return !this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>

<style scoped></style>
